<i18n>
{
  "en": {
    "logout": "Log out"
  },
  "fr": {
    "logout": "Déconnexion"
  }
}
</i18n>
<template>
  <v-app-bar dark app clipped-left color="accent">
    <!--
    <v-toolbar-side-icon @click.stop="onClickBtn" class="hidden-lg-and-up"></v-toolbar-side-icon> -->
    <v-toolbar-title class="headline text-uppercase">
      <router-link to="/" class="toolbar-title">
        <span class="font-weight-light">
          {{ getAppName }}
        </span>
    </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn icon @click="logout()" v-if="isAuthenticated">
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
export default {
  name: 'appToolbar',
  methods: {
    async logout () {
      try {
        await this.$store.dispatch('logoutUser')
        this.$router.push('/login')
      } catch (err) {
        console.error(err)
      }
    }
  },
  computed: {
    getAppName () {
      return this.$store.getters.getAppName
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>
<style scoped>
.toolbar-title {
  color: inherit;
  text-decoration: inherit;
}
</style>
